import PropTypes from 'prop-types';

import styles from './ContentPanel.scss';

export function ContentPanel({ children }) {
  return (
    <div className={styles.root}>
      {children}
    </div>
  );
}

ContentPanel.propTypes = {
  children: PropTypes.node,
};
